(ns pfo.tz
  (:require 
    ajax.core
    [cljs-time.coerce :as time-coerce]
    [cljs-time.core :as time-core :refer [minus plus]]
    [pfo.api :as api]
    [pfo.time :refer [now-millis now-js-date now]]))

(declare get-user-timezone get-offset)

(defn to-user-timezone [dt]
  (if-let [tz (not-empty (api/get-auth-info :timezone))]
    (let [offset (.offset (.zone (.-tz js/moment) tz) (now-millis))]
      (.toDate (.stripZone (.zone (.tz (js/moment (time-coerce/to-date dt)) tz) (- offset (.getTimezoneOffset (now-js-date)))))))
    dt))

(defn parsed-date-to-browser-date [dt]
  (js/Date. (+ (.getTime dt) (* 60000 (get-offset)))))

(defn from-user-timezone [dt]
  (if-let [tz (not-empty (api/get-auth-info :timezone))]
    (let [offset (.offset (.zone (.-tz js/moment) tz) (now-millis))]
      (.toDate (.stripZone (.zone (.tz (js/moment (time-coerce/to-date dt)) tz) (- (- offset (.getTimezoneOffset (now-js-date))))))))
    dt))

(defn get-offset []
  (let [jan (js/Date. (.getFullYear (now-js-date) 0 1))
        jul (js/Date. (.getFullYear (now-js-date) 6 1))]
    (max (.getTimezoneOffset jan) (.getTimezoneOffset jul))))

(defn is-same-offset [dt tz1 tz2]
  (=
   (.offset (.zone (.-tz js/moment) tz1) dt)
   (.offset (.zone (.-tz js/moment) tz2) dt)))

(defn at-midnight [dt]
  (let [tz (get-user-timezone)]
    (time-coerce/from-date (to-user-timezone (time-coerce/from-date (.toDate
                                                (js/moment (.startOf (js/moment
                                                                       (.tz (js/moment (time-coerce/to-date dt)) tz)) "day"))))))))

(defn in-user-timezone [dt]
  (if-let [tz (not-empty (api/get-auth-info :timezone))]
    (time-core/to-default-time-zone dt)
    (time-core/to-default-time-zone dt)))
(defn to-browser-time
  "Takes a cljs-time object (e.g. result of parsing) and returns one that consider's user's timezone preference.
  This preference can be different from system/browser timezone, this function adjusts the time so that when
  formatted using cljs-time formatting functions, a correct date and time is displayed. So basically it works
  around browser's timezone in cases when user tz preference is different."
  [atime]
  (time-core/to-default-time-zone (time-coerce/from-date (to-user-timezone atime))))

;; (defn in-user-timezone [dt]
;;   (if-let [tz (not-empty (api/get-auth-info :timezone))]
;;     (time-core/to-default-time-zone dt)
;;     (time-core/to-default-time-zone dt)))

(defn get-non-default-tz-abbr []
  (when-let [user-tz (not-empty (api/get-auth-info :timezone))]
    (let [now (now-millis)
          zone (.zone (.-tz js/moment) user-tz)]
      (when-not (= (.offset zone now)
                  (.getTimezoneOffset (now-js-date)))
       (.abbr zone now)))))

(defn get-user-timezone []
  (or (not-empty (api/get-auth-info :timezone)) (.guess (.-tz js/moment))))

;; Returns time according to iPaladin's timezone
(defn now-for-user []
  (let [now-time (now)
        browser-offset (.getTimezoneOffset now-time)
        offset (.offset (.zone (.-tz js/moment) (get-user-timezone)) (time-coerce/to-long now-time)) ]
    (plus (minus now-time (time-core/minutes offset)) (time-core/minutes browser-offset))))
